import { useRouter } from 'next/router';

import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

export function useCuration(campaignId?: string) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();
  const router = useRouter();

  console.log(
    '🔍 [useCuration] campaignId:',
    campaignId,
    'router.isReady:',
    router.isReady,
    'token:',
    !!token
  );

  const enabled = !!token && !!campaignId && router.isReady;

  const {
    data = {},
    error,
    isLoading,
    refetch
  } = useQuery({
    queryKey: 'client-campaign-curation',
    queryFn: async () => {
      return getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/client/campaign/${campaignId}/curation`,
        token
      }).then((response: Api.Client.Curation[] | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      });
    },
    queryData: { id: campaignId, token },
    enabled
  });

  return {
    data,
    error,
    isLoading,
    refetch
  };
}
